<template>
  <div class="articles-for-category">
    <div class="last-articles">
      <div class="line">
        <div>Résultats pour '{{ $route.params.query }}'</div>
      </div>
      <div class="row">
        <articles-query :tags="['animasoft_oid']" :query="$route.params.query">
          <template slot-scope="props">
            <div v-for="article in props.articles">
              <article-preview :article="article"></article-preview>
            </div>
          </template>
        </articles-query>
      </div>
    </div>
  </div>
</template>

<script>
  import { ArticlesQuery } from 'itrnews-vuejs-api';
  import ArticlePreview from './elements/ArticlePreview';

  export default {
    name: 'ArticlesSearch',
    components: { ArticlesQuery, ArticlePreview },
  };
</script>



// WEBPACK FOOTER //
// src/components/ArticlesSearch.vue